import ShopListSelectPrefecture from '~/containers/shops/shoplist_select_prefecture'

export default ShopListSelectPrefecture
